import { GzAntimalwareOnDemandContextualScanFormWebComponent } from './component/GzAntimalwareOnDemandContextualScanFormWebComponent';

export { GzAntimalwareOnDemandContextualScanFormWebComponent };
